import React from 'react';

import { UserData } from '../types/user';
import useUsers from './useUsers';

const useUser = (uuid: string): { user?: UserData; isLoading: boolean } => {
  const { users, isLoading } = useUsers([uuid]);
  const user = React.useMemo(() => users.find((user) => user.id === uuid), [users, uuid]);
  return { user: user, isLoading };
};

export default useUser;
